import './PageNotFound.css';


export default function PageNotFound() {

  return (
    //   <div className="main-layout">
    //     <div className="row">
    //         <div className="content col-md-12">
    //             <div className="main_content">
    //                 <div id="error-page">
    //                     <h1>Oops!</h1>
    //                     <p>Sorry, an unexpected error has occurred.</p>
    //                 </div>
    //             </div>
    //         </div>
    //     </div>
    //   </div>
        <div className="d-flex justify-content-center align-items-center page_not_wrapper">
            <div className="col-md-6 text-center">
                    <img src="/img/code-error.png" width="150" alt="Logo" />
                    <br/>
                    <br/>

                    <h2>That's an error.</h2>
                    <p>The requested URL was not found on this server. That's all we know.</p>
                    <br/>
                    <a className="back_home_btn" href="/users/user_dashboard"><i className="fa fa-arrow-circle-left" aria-hidden="true"></i> Back to home</a>
            </div>
        </div>
  );
}